import React, { Fragment } from 'react';
import '../../CourseCounselling/ScheduleCourseCounselling.css';
import config from '../../../config';
import statsCount from '../../../Data/statsCount';
import { SignupContainer, SignupWrapper, SignupInfoTitle, StatsDiv, SignupStats, SignupInfoShape } from './styles';
import SiteButton from '../Button/siteButtons';
// import PartnerPlusButton from '../Button/partnerPlusButtons';
// import RegionalsButton from '../Button/regionalsButtons';
// import CodeJuniorsButton from '../Button/codeJuniorsButton';
import { BsPeople, BsGlobe } from 'react-icons/bs';

export default function SignupInfo({ cloudFront, isDsa, isPython, isCprg, coursesLanguage, variant }) {
  return (
    <Fragment>
      {/*{variant === 'partner-plus' ? (
        <SignupContainer>
          <SignupWrapper variant="partner-plus">
            <SignupInfoTitle>Grow your Programming skills with Log2Base2®</SignupInfoTitle>
            <StatsDiv>
              <SignupStats marginSpacing variant="partner-plus">
                <BsPeople className="fs-20 partnerPlusTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Users.alphaNumeric}+ Learners</span>
              </SignupStats>
              <SignupStats variant="partner-plus">
                <BsGlobe className="fs-20 partnerPlusTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Countries.integer} Countries</span>
              </SignupStats>
            </StatsDiv>
            <PartnerPlusButton
              signUpInfoBtn
              style={{ zIndex: 1 }}
              onClick={() => (window.location.href = `${config.domain}/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=ptnr-sgn-info_btn`)}
            >
              Start Learning
            </PartnerPlusButton>
            <SignupInfoShape data={cloudFront + '/Assets/PartnerPlus/PaleGreenCornerShape.svg'} bottomLeft></SignupInfoShape>
            <SignupInfoShape data={cloudFront + '/Assets/PartnerPlus/PaleGreenCornerShape.svg'} topRight></SignupInfoShape>
          </SignupWrapper>
        </SignupContainer>
      ) : variant === 'regionals' ? (
        <SignupContainer>
          <SignupWrapper variant="regionals">
            <SignupInfoTitle>Grow your Programming skills with Log2Base2®</SignupInfoTitle>
            <StatsDiv>
              <SignupStats marginSpacing variant="regionals">
                <BsPeople className="fs-20 regionalsDarkTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Users.alphaNumeric}+ Learners</span>
              </SignupStats>
              <SignupStats variant="regionals">
                <BsGlobe className="fs-20 regionalsDarkTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Countries.integer} Countries</span>
              </SignupStats>
            </StatsDiv>
            <RegionalsButton
              signUpInfoBtn
              style={{ zIndex: 1 }}
              onClick={() => (window.location.href = `${config.domain}/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnl-sgn-info_btn`)}
            >
              Start Learning
            </RegionalsButton>
            <SignupInfoShape data={cloudFront + '/Assets/Regionals/PalePurpleCornerShape.svg'} bottomLeft></SignupInfoShape>
            <SignupInfoShape data={cloudFront + '/Assets/Regionals/PalePurpleCornerShape.svg'} topRight></SignupInfoShape>
          </SignupWrapper>
        </SignupContainer>
      ) : variant === 'code-juniors' ? (
        <SignupContainer>
          <SignupWrapper variant="code-juniors">
            <SignupInfoTitle>Grow your Programming skills with Log2Base2®</SignupInfoTitle>
            <StatsDiv>
              <SignupStats marginSpacing variant="code-juniors">
                <BsPeople className="fs-20 codeJuniorsTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Users.alphaNumeric}+ Learners</span>
              </SignupStats>
              <SignupStats variant="code-juniors">
                <BsGlobe className="fs-20 codeJuniorsTxt" />
                <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Countries.integer} Countries</span>
              </SignupStats>
            </StatsDiv>
            <CodeJuniorsButton
              signUpInfoBtn
              style={{ zIndex: 1 }}
              onClick={() => (window.location.href = `${config.domain}/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=cdjns-sgn-info_btn`)}
            >
              Start Learning
            </CodeJuniorsButton>
            <SignupInfoShape data={cloudFront + '/Assets/Juniors/PaleOrangeCornerShape.svg'} bottomLeft></SignupInfoShape>
            <SignupInfoShape data={cloudFront + '/Assets/Juniors/PaleOrangeCornerShape.svg'} topRight></SignupInfoShape>
          </SignupWrapper>
        </SignupContainer>
      ) : (
      )}*/}
      <SignupContainer>
        <SignupWrapper>
          <SignupInfoTitle>
            Grow your {isDsa ? 'Data Structures and Algorithms' : isPython ? 'Python' : isCprg ? 'C Programming' : 'Programming'} skills with Log2Base2®
          </SignupInfoTitle>
          <StatsDiv>
            <SignupStats marginSpacing>
              <BsPeople className="fs-20" />
              <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Users.alphaNumeric}+ Learners</span>
            </SignupStats>
            <SignupStats>
              <BsGlobe className="fs-20" />
              <span className="headingFont normalTxt weight-500 pl-2">{statsCount.Countries.integer}+ Countries</span>
            </SignupStats>
          </StatsDiv>
          <SiteButton
            signUpInfoBtn
            style={{ zIndex: 1 }}
            onClick={() => (window.location.href = `${config.domain}/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=stln-info_btn`)}
          >
            Start Learning
          </SiteButton>
          <SignupInfoShape data={cloudFront + '/Assets/PaleBlueCornerShape.svg'} bottomLeft></SignupInfoShape>
          <SignupInfoShape data={cloudFront + '/Assets/PaleBlueCornerShape.svg'} topRight></SignupInfoShape>
        </SignupWrapper>
      </SignupContainer>
    </Fragment>
  );
}
